import React, { useContext, useState } from "react";
import { FaQuestionCircle, FaChevronDown, FaChevronUp } from "react-icons/fa";
import "react-toastify/dist/ReactToastify.css";
import themeContext from "../../themeContext/themeContext";
import {
  ContactSectionContainer,
  FAQContainer,
  Question,
  Answer,
  FAQItem,
  IconWrapper,
  AnswerContainer,
  QuestionHeader,
} from "./styledComponents";
import "./index.css";

function ContactSection() {
  const { isDarkMode } = useContext(themeContext);
  const [openIndex, setOpenIndex] = useState(null);

  const faqList = [
    {
      question: "How can we be a part of this Training System ?",
      answer: (
        <div>
          You can be a part of the Boot Camp by:
          <ul>
            <li className="listpoints">
              <strong>👉 Advance Slot Booking:</strong>If you are ready to start
              immediately, you can choose this option. Simply book your slot in
              advance and pay ₹199 along with submitting your details. After
              that, we will reach out to you within 24 hours to confirm your
              registration.
            </li>
            <li className="listpoints">
              <strong>👉 Register Your Slot:</strong>Alternatively, you can
              register your slot without immediate payment. Our team will get in
              touch with you within 3 to 4 business days to finalize your
              registration and provide further instructions.
            </li>
          </ul>
        </div>
      ),
    },

    {
      question: "What is the reason for the 3-Day Boot Camp?",
      answer:
        "The main reason for the 3-Day Boot Camp is to provide a comprehensive introduction to your job title, your role within the company, and the overall work processes. This immersive program is designed to ensure that you fully understand your responsibilities, the expectations of your position, and how you can effectively contribute to the team's success. Through detailed explanations and hands-on activities, the boot camp aims to equip you with the knowledge and skills needed to excel in your new role.",
    },
    {
      question: "Why do we charge ₹199 for Training?",
      answer:
        "We charge ₹199 for the training to filter out the true candidates who are genuinely interested in working with us, ensuring that we don't waste anyone's time. This nominal fee helps us identify serious applicants and maintain the quality of our training sessions.",
    },
    {
      question: "What is the UPI transaction ID while booking a slot?",

      answer: (
        <div>
          <p>
            `The UPI transaction ID is a secure payment identifier that helps to
            easily identify individuals and enhances security for future
            transactions. It helps protect against fraud. Here is an example of
            how a UPI transaction ID looks like:{" "}
          </p>
          <div class="imagecontainer">
          <img
            src="https://prod4-sprcdn-assets.sprinklr.com/200101/2074a36c-39e4-4da7-81ad-711eef2f21a1-31077971/Screenshot_2022-02-09_at_3.24..png"
            alt="UPI Transaction ID"
            className="images"
          />
          `</div>
        </div>
      ),
    },
    {
      question: "What are the work timings, and is part-time available?",
      answer:
        "Yes, we offer both part-time and full-time options with flexible hours. Additionally, there are work-from-home opportunities available to accommodate different schedules and preferences.",
    },
    {
      question: "Do we need a laptop for this work?",
      answer:
        "No, you can work using a mobile device as long as you have a good internet connection.",
    },
    {
      question:
        "What is the difference between corporate training and this training?",
      answer:
        "Corporate training focuses on improving the productivity of employees within a company, whereas our training provides personal development and individual growth.",
    },
    {
      question: "Who can apply for this?",

      answer:
        "Every person who is 18 years or older can apply, regardless of their educational background. There is no age discrimination.",
    },
    {
      question: "Is the training conducted online or offline?",
      answer:
        "Our training program is conducted online, allowing you to participate from the comfort of your home or any location with internet access. This format offers flexibility and convenience, making it easier to fit the training into your schedule. Our online platform provides interactive sessions, live lectures, and hands-on exercises, ensuring a comprehensive learning experience. Additionally, all training materials and resources are accessible online, so you can review and practice at your own pace.",
    },
    {
      question: "What is the duration of the training program?",
      answer:
        "Our training spans 3 transformative days:  Day 1: Discover our company’s dynamic profile. Day 2: Understand the daily working process.  Day 3: Decide if you want to start working part-time or full-time.",
    },
    {
      question: "What is the name of the organization?",
      answer:
        "Our organization is called Achievers Clubs, an innovative Indian startup proudly associated with the Digital India flagship program. Achievers Clubs is dedicated to empowering individuals through cutting-edge digital solutions and training, driving progress and innovation in the digital landscape of India.",
    },
    {
      question: "Is this a government-registered company with a license?",
      answer:
        "Yes, Achievers Clubs is a government-recognized company. We are proud to be associated with the Digital India Project, a flagship program of the Government of India. Launched on July 1, 2015, this visionary initiative aims to transform India into a digitally empowered society and knowledge economy. Our alignment with this program underscores our commitment to contributing to India's digital transformation and innovation.",
    },

    {
      question: "How do I get my queries resolved during the training?",
      answer:
        "Our dedicated team is committed to ensuring you have a smooth and enriching training experience. Throughout the three-day program, our team will be in constant touch with you, ready to resolve any queries or concerns you may have. Your success is our priority, and we are here to support you every step of the way.",
    },

    {
      question: "What will be the main work after the three-day training ?",
      answer:
        "After the three-day training, your main responsibilities will involve team management, overseeing the recruitment process, and optimizing our social media presence. These roles are crucial for driving our organization's growth and success.",
    },
    {
      question: "Do we get a refund if we don't like the session?",
      answer:
        "Our policy is that fees are non-refundable. We strive to provide high-quality content and a valuable learning experience in every session. We encourage you to review the course details thoroughly before enrolling to ensure it meets your expectations.",
    },
  ];

  const handleToggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <ContactSectionContainer id="FAQS" isDarkMode={isDarkMode}>
      <h1 className="qandaheading">Clear Your Doubts</h1>
      <FAQContainer isDarkMode={isDarkMode}>
        {faqList.map((faq, index) => (
          <FAQItem key={index}>
            <QuestionHeader onClick={() => handleToggle(index)}>
              <IconWrapper>
                <FaQuestionCircle />
              </IconWrapper>
              <Question>{faq.question}</Question>
              <IconWrapper>
                {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
              </IconWrapper>
            </QuestionHeader>
            {openIndex === index && (
              <AnswerContainer>
                <Answer>{faq.answer}</Answer>
              </AnswerContainer>
            )}
          </FAQItem>
        ))}
      </FAQContainer>
    </ContactSectionContainer>
  );
}

export default ContactSection;
